import { Link } from 'react-router-dom';

const NotFound = () => (
  <div className="min-h-[65vh] bg-white py-24 text-center">
    <h1 className="mb-4 text-5xl font-bold">Página no encontrada</h1>
    <p className="mb-8 text-lg text-gray-600">La dirección no existe o la página fue movida.</p>
    <Link className="font-semibold underline" to="/">Volver al inicio</Link>
  </div>
);

export default NotFound;
